import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Menu = (props) => (
    <nav id="menu">
        <div className="inner">
            <ul className="links">
                <li><Link onClick={props.onToggleMenu} to="/">Home</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/#projects">Projetos</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/conto-autoral">Conto Autoral</Link></li>
            </ul>
            <ul className="actions vertical">
                <li><a className="button fit" href="/admin">Administrativo</a></li>
            </ul>
        </div>
        <button className="close" onClick={props.onToggleMenu} href="#">Close</button>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Menu
